/**
 * defa.collections.warmupSettings
 * A Collection of WarmupSetting
 * @version 1.2.0
 */
import WarmupSetting from 'scripts/defa/control/warmup-settings/model-warmup-setting';

const WarmupSettings = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : WarmupSetting,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------

} );


export default WarmupSettings